import React from "react";
import { useI18n } from "../i18n/I18nContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// The redirect MUST come from window.location.origin so the user lands back on the same domain
// they started from (preview vs production), and the Emergent platform returns them with a
// `#session_id=...` fragment for the AuthCallback to process.

/**
 * Continue-with-Google button.
 * @param {string} next  Path (with optional query) to land on after sign-in. Falls back to current path.
 * @param {string} testId
 * @param {string} className extra classes
 */
export default function GoogleSignInButton({ next, testId = "google-signin-btn", className = "" }) {
  const { t } = useI18n();

  const onClick = () => {
    const target = next || (window.location.pathname + window.location.search);
    const redirectUrl = window.location.origin + "/auth/callback?next=" + encodeURIComponent(target);
    window.location.href = "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={
        "w-full inline-flex items-center justify-center gap-3 bg-white hover:bg-neutral-100 " +
        "text-neutral-900 font-condensed tracking-[0.12em] uppercase text-[12px] " +
        "py-3 px-5 border border-neutral-200 transition-colors " +
        className
      }
    >
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.13-.84 2.08-1.79 2.72v2.26h2.9c1.7-1.56 2.69-3.87 2.69-6.62z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.9-2.26c-.81.54-1.84.86-3.06.86-2.35 0-4.34-1.58-5.05-3.71H.96v2.33C2.43 15.98 5.48 18 9 18z"/>
        <path fill="#FBBC05" d="M3.95 10.71A5.41 5.41 0 0 1 3.66 9c0-.59.1-1.17.29-1.71V4.96H.96A8.997 8.997 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.99-2.33z"/>
        <path fill="#EA4335" d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0 5.48 0 2.43 2.02.96 4.96L3.95 7.29C4.66 5.16 6.65 3.58 9 3.58z"/>
      </svg>
      <span>{t("auth.continueWithGoogle", "Continue with Google")}</span>
    </button>
  );
}
